import type { Enum, EnumGroup } from 'types/core';
import type { IStore } from 'types/custom/offers';

export const azureAdProvider = 'azure-ad';
export const clientId = '3d238c89-9e2e-40d7-9737-7bc282ca5ad3';
export const defaultScopes = [`${clientId}/.default`];
export const adTenantId = '81fa766e-a349-4867-8bf4-ab35e250a08f';
export const adAuthority = `https://login.microsoftonline.com/${adTenantId}`;
export const assortmentScope = 'cc398fd0-bf42-44c0-9de8-ac5360f5bf67/.default';

export const OFFERS_NAMESPACE_CONFIG = {
  namespace: 'offers',
  object: ['offers', 'financial-offers', '*'],
  relation: ['admin', 'create', 'modify', 'delete', 'entry'],
};

const CASH: Enum = {
  id: 'cash',
  name: 'Cash',
};

const LEASE: Enum = {
  id: 'lease',
  name: 'Lease',
};

const LOAN: Enum = {
  id: 'loan',
  name: 'Loan',
};

const SUB: Enum = {
  id: 'sub',
  name: 'Subscription',
};

const SUB_FIXED: Enum = {
  id: 'sub_fixed',
  name: 'Subscription fixed',
};

export const salesModels: EnumGroup = {
  cash: CASH,
  lease: LEASE,
  loan: LOAN,
  sub: SUB,
  sub_fixed: SUB_FIXED,
};

const WHOLESALE: Enum = {
  id: 'wholesale',
  name: 'Wholesale',
};

const DIRECT: Enum = {
  id: 'direct',
  name: 'Direct sale',
};

export const businessModels: EnumGroup = {
  wholesale: WHOLESALE,
  direct: DIRECT,
};

const VCC: Enum = {
  id: 'vcc',
  name: 'Volvo Cars',
};

export const brands: EnumGroup = {
  vcc: VCC,
};

export const types = [
  {
    key: 'bundle',
    label: 'Bundle',
  },
  {
    key: 'configurableProduct',
    label: 'Configurable product',
  },
  {
    key: 'commercialItem',
    label: 'Commercial item',
  },
  {
    key: 'componentConfiguration',
    label: 'Component configuration',
  },
  {
    key: 'component',
    label: 'Component',
  },
];

const GROSS: 'Gross' = 'Gross';
const NET: 'Net' = 'Net';
export const CONFIGURABLE_PRODUCT = 'configurableProduct';

export const priceBases = {
  GROSS,
  NET,
};

const ERROR: 'error' = 'error';
const WARNING: 'warning' = 'warning';
const INFO: 'info' = 'info';

export const messageTypes = {
  ERROR,
  WARNING,
  INFO,
};

const {
  isQA,
  isDev,
  isProd,
}: { isLocal?: boolean; isDev?: boolean; isQA?: boolean; isProd?: boolean } =
  (() => {
    if (typeof window !== 'undefined' && window?.location?.hostname) {
      switch (window.location.hostname.toLowerCase()) {
        case 'product-catalog-test.volvocars.biz':
          return { isDev: true };
        case 'product-catalog-qa.volvocars.biz':
          return { isQA: true };
        case 'product-catalog.volvocars.biz':
          return { isProd: true };
      }
    }

    return {};
  })();

export const launchDarklyClientId = isProd
  ? '640b4e163f8d3a13f9a9359a'
  : isQA
    ? '640b4e5b21be3713613347d8'
    : isDev
      ? '640b4e4d21be3713613347c5'
      : undefined;

export const PRODUCT_SERVICE_URL = isProd
  ? 'https://product-service.volvocars.biz/vcc'
  : isQA
    ? 'https://product-service-qa.volvocars.biz/vcc'
    : 'https://product-service-external.weu-dev.ecpaz.volvocars.biz/vcc';

export const PRISM_GLOBAL_MARKET_ID = 'a2b4a96f-8a8a-4ddd-b57d-7b7fe29df663';

export const PRISM_URL = `https://prism-admin-external.weu-${isProd ? 'prod' : isQA ? 'qa' : 'dev'}.ecpaz.volvocars.biz/vcc`;

export const REQUIRED_ENV = [
  'FED_GRAPH_URL',
  'FED_GRAPH_CLIENT_KEY',
  'FED_GRAPH_CLIENT_NAME',

  'OFFERS_API_URL',
  'OFFERS_CLIENT_ID',

  'OFFERS_V2_API_URL',
  'OFFERS_V2_CLIENT_ID',

  'PRICE_DATA_API_URL',
  'PRICE_DATA_CLIENT_ID',

  'PRICING_CATALOG_API_URL',

  'FINANCING_OFFERS_API_URL',
  'FINANCING_OFFERS_CLIENT_ID',

  'VCC_API_KEY',
  'VCC_API_URL',
  'ASSORTMENT_ADMIN_API_URL',
  'POP_AUTHZ_API_URL',
  'NEXTAUTH_URL',
  'NEXTAUTH_SECRET',
  'AZURE_CLIENT_SECRET',

  'GPE_CONFIG_API_URL',
  'GPE_CONFIG_CLIENT_ID',

  'PARTNERS_API_URL',
  'PARTNERS_API_CLIENT_ID',
  'PARTNERS_API_CLIENT_SECRET',
  'PARTNERS_API_SUBSCRIPTION_KEY',
];

export const PARTNERS_TOKEN_PATH = '/access-token/oauth2/token';
export const PARTNERS_GRAPHQL_PATH = '/commercial-partner-graphql';

export const DEFAULT_MARKET_CODE = 'GLOBAL';

export const GLOBAL_STORE: IStore = {
  id: DEFAULT_MARKET_CODE,
  market: { name: 'Global', code: DEFAULT_MARKET_CODE },
};

export const EMPTY_GUID = '00000000-0000-0000-0000-000000000000';

export const CAR_PRODUCT_GROUP_CODE = 'car';

export const MAX_CACHE_SIZE = 100;
export const CACHE_TTL_MS = 5 * 60 * 1000; // 5 minutes
